/** Nombre maximum d'itérations d'appels de tools par boucle d'agent */
export const MAX_TOOL_ITERATIONS = 15

/** Budget de thinking (tokens) pour les modèles qui supportent le reasoning */
export const THINKING_BUDGET = 8192

/** Nombre maximum de caractères pour un titre de conversation généré */
export const TITLE_MAX_LENGTH = 80

/** Nombre maximum de caractères pour le titre temporaire (avant génération par le LLM) */
export const TITLE_PREVIEW_LENGTH = 50

/** Nombre maximum de caractères autorisés dans le résumé compact */
export const COMPACT_SUMMARY_MAX_LENGTH = 2_000
